module.exports = __webpack_public_path__ + "01bf40e7f481a00f08efa58d23c5b6c7.gif";


//////////////////
// WEBPACK FOOTER
// ./assets/images/paywalls/text-table.gif
// module id = 2729
// module chunks = 0